import React, { useRef } from "react";
import { FixedSizeGrid as Grid } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer"; // Optional, for responsive width
import { CardSelected } from "../../type";
import { Cards } from "../Cards/Cards";

interface CardBoardProps {
  cardsBoard: CardSelected[];
  setCardsBoard: (arg1: CardSelected[]) => void;
  setEditCard?: (arg1: string | null) => void;
  setOpenModalChoosePrice?: (arg1: string | null) => void;
  removeDelete?: boolean;
  cardsBoardFiltered: CardSelected[];
  setCardsClicked?: React.Dispatch<React.SetStateAction<string[]>>;
  cardsClicked?: string[];
  hasAction?: boolean;
}

const CARD_WIDTH = 320;
const CARD_HEIGHT = 320;
const GAP = 10;

export const CardBoard = ({
  cardsBoard,
  setEditCard,
  setOpenModalChoosePrice,
  setCardsBoard,
  removeDelete = false,
  cardsBoardFiltered,
  setCardsClicked,
  cardsClicked,
  hasAction = true,
}: CardBoardProps) => {
  const gridRef = useRef(null);

  const onDeleteCard = (uid: string | null) => {
    setCardsBoard(cardsBoard.filter((card) => card.uid !== uid));
  };

  const onCardSelectHandler = (uid: string) => {
    setCardsClicked?.((prev: string[]) => {
      if (prev.includes(uid)) {
        return prev.filter((id: string) => id !== uid);
      } else {
        return [...prev, uid];
      }
    });
  };

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <AutoSizer>
        {({ height, width }: { height: number; width: number }) => {
          const columnCount = Math.floor(width / (CARD_WIDTH + GAP));
          const rowCount = Math.ceil(cardsBoardFiltered.length / columnCount);

          return (
            <Grid
              ref={gridRef}
              columnCount={columnCount}
              columnWidth={CARD_WIDTH + GAP}
              height={height}
              rowCount={rowCount}
              rowHeight={CARD_HEIGHT + GAP}
              width={width}
              itemData={{
                columnCount,
                onDeleteCard,
                setEditCard,
                setOpenModalChoosePrice,
                removeDelete,
                cardsBoardFiltered,
                cardsClicked,
                onCardSelectHandler,
                hasAction,
              }}
            >
              {CardGridItem}
            </Grid>
          );
        }}
      </AutoSizer>
    </div>
  );
};

interface CardGridItemProps {
  columnIndex: number;
  rowIndex: number;
  style: React.CSSProperties;
  data: {
    columnCount: number;
    onDeleteCard: (index: string | null) => void;
    setEditCard?: (index: string | null) => void;
    setOpenModalChoosePrice?: (index: string | null) => void;
    removeDelete?: boolean;
    cardsBoardFiltered: CardSelected[];
    cardsClicked?: string[];
    onCardSelectHandler?: (arg1: string) => void;
    hasAction?: boolean;
  };
}

const CardGridItem = ({
  columnIndex,
  rowIndex,
  style,
  data,
}: CardGridItemProps) => {
  const {
    columnCount,
    onDeleteCard,
    setEditCard,
    setOpenModalChoosePrice,
    removeDelete,
    cardsBoardFiltered,
    cardsClicked,
    onCardSelectHandler,
    hasAction,
  } = data;
  const index = rowIndex * columnCount + columnIndex;

  if (index >= cardsBoardFiltered.length) return null;

  const card = cardsBoardFiltered[index];

  return (
    <div style={{ ...style, padding: 5 }}>
      <Cards
        card={card}
        key={`${card.id}-${index}`}
        hasAction={hasAction}
        onDeleteCard={removeDelete ? undefined : onDeleteCard}
        setEditCard={setEditCard}
        setOpenModalChoosePrice={setOpenModalChoosePrice}
        cardsClicked={cardsClicked}
        onCardSelectHandler={onCardSelectHandler}
      />
    </div>
  );
};
